export default __webpack_public_path__ + "static/media/currency_ils.0f73436a.svg";